import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Typography,
  Modal,
  Divider,
  DialogActions,
  FormControl,
  FormLabel,
  TextField,
} from '@material-ui/core'
import {
    SORIANA_AZURE_USER_TYPE,
    SORIANA_TRADITIONAL_USER_TYPE,
} from '../../../commons/constants';
import { isValidURL } from '../../../utils/strings';

const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3
}

export default function SorianaCredentials({
  portalData,
  b2bTable,
  rowIndex,
  setB2bFormData,
  disabled = false,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [isSaved, setIsSaved] = useState(false)
  const [errors, setErrors] = useState({})
  const [username, setUsername] = useState(portalData.username || '')
  const [password, setPassword] = useState(portalData.password || '')
  const [rut, setRut] = useState(portalData.rut || '')

  const isTraditional = portalData.portal.userType === SORIANA_TRADITIONAL_USER_TYPE
  const isAzure = portalData.portal.userType === SORIANA_AZURE_USER_TYPE

  const isDataValid = () => {
    let isValid = false
    setErrors({})
    const newErrors = {}

    if (isTraditional) {
      if (!username) newErrors.username = 'El campo no debe quedar vacío'
      if (!password) newErrors.password = 'El campo no debe quedar vacío'
    } else if (isAzure) {
      if (!rut) newErrors.rut = 'El campo no debe quedar vacío'
      if (!isValidURL(rut)) newErrors.rut = 'La URL debe ser válida'
    }

    if (Object.keys(newErrors).length) {
      setErrors((prevState) => ({
        ...prevState,
        ...newErrors,
      }))
    } else {
      isValid = true
    }

    return isValid
  }

  const handleSubmitForm = (e) => {
    e.preventDefault()

    if (isDataValid()) {
      const b2bTableRecord = b2bTable[rowIndex]

      if (isTraditional) {
        b2bTableRecord.rut = null
        b2bTableRecord.username = username
        b2bTableRecord.password = password
      } else {
        b2bTableRecord.rut = rut
        b2bTableRecord.username = 'N/A'
        b2bTableRecord.password = 'N/A'
      }

      const updatedB2BTable = [...b2bTable]
      updatedB2BTable[rowIndex] = b2bTableRecord
  
      setB2bFormData(updatedB2BTable)
      setIsSaved(true)
      setIsOpen(false)
    }
  }

  const handleCloseModal = () => {
    if (!isSaved) {
      setUsername('')
      setPassword('')
      setRut('')
    }

    setErrors({})
    setIsOpen(false)
  }

  useEffect(() => {
    setIsSaved(false)

    if (isTraditional) {
      setRut('')
    } else {
      setUsername('')
      setPassword('')
    }
  }, [portalData.portal.userType])

  return (
    <div>
      <Button className="isv-btn isv-btn-circle" onClick={() => setIsOpen(true)} disabled={disabled}>
        Credenciales
      </Button>

      <Modal
        open={isOpen}
        onClose={handleCloseModal}
      >
        <Box sx={boxStyle} component="form" autoComplete="off" onSubmit={handleSubmitForm}>
          <Typography id="modal-modal-title" variant="h4">
            Ingresar Credencial
          </Typography>
          <Divider />
          <br />

          {isTraditional && (
            <>
              <FormControl className="MuiFormControl-fullWidth">
                <FormLabel>Usuario</FormLabel>
                <TextField
                  error={'username' in errors}
                  label={'username' in errors ? errors.username : ''}
                  variant="outlined"
                  name="username"
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                />
              </FormControl>
              <br/>
              <br/>

              <FormControl className="MuiFormControl-fullWidth">
                <FormLabel>Clave</FormLabel>
                <TextField
                  error={'password' in errors}
                  label={'password' in errors ? errors.password : ''}
                  variant="outlined"
                  name="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </FormControl>
              <br/>
            </>
          )}

          {isAzure && (
            <>
              <FormControl className="MuiFormControl-fullWidth">
                <FormLabel>Link</FormLabel>
                <TextField
                  error={'rut' in errors}
                  label={'rut' in errors ? errors.rut : ''}
                  variant="outlined"
                  name="rut"
                  onChange={(e) => setRut(e.target.value)}
                  value={rut}
                />
              </FormControl>
              <br/>
            </>
          )}

          <br/>

          <DialogActions>
            <Button className="isv-btn isv-btn-circle btn-warning" onClick={handleCloseModal}>
              Cerrar
            </Button>
            <Button className="isv-btn isv-btn-circle" type="submit">
              Guardar
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </div>
  )
}
